import { useAuth } from "../auth/AuthContext";

const LoadingScreen = () => {
  const { loading } = useAuth();

  if (!loading) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-90 z-50">
      <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-black-500"></div>
    </div>
  );
};

export default LoadingScreen;
